import React from "react"
import "./footer.css"

const Footer = () => {
  const today = new Date();
  const year = today.getFullYear();

  return (
    <>
      <div className='follow'>
        {/* <div className="subscribe">Click 
          <a href="/contact"> here to subscribe</a> for updates
        </div> */}
        <div className="social"> Follow us on:
          <a href="/contact"><i className="fab fa-facebook-f"></i></a>
          <a href="https://www.instagram.com/metadecorevents"><i className="fab fa-instagram"></i></a>
          <a href="https://www.tiktok.com/@metadecorevents"><i className="fab fa-tiktok"></i></a>
          <a href="https://wa.me/c/27646122609"><i className="fab fa-whatsapp"></i></a>
        </div>
      </div>
      <div className='legal'>
        <span>&copy; {year} Meta Decor and Event Management. All rights reserved.</span>
      </div>
      {/* <section className='footerContact'>
        <div className='container'>
          <div className='send flex'>
            <div className='text'>
              <h1>Do You Have Questions ?</h1>
              <p>We'll help you find the best for your wedding or party.</p>
            </div>
            <button className='btn5'>
              <a href="https://wa.me/+27646122609">Chat with us on whatsapp</a>
            </button>
          </div>
        </div>
        where to find us : location
        call us on:
        catch us on the socials
      </section> */}
      
      
    </>
  )
}

export default Footer
